import { Container } from "@mui/material";
import { Box } from "@mui/system";
import ContactForm from "../components/ContactForm";

export default function ContactUsPage() {
    return <Container component="main" maxWidth="lg">
            <ContactForm/>    
    </Container>
}